import styled from '@emotion/styled';
import { rem } from 'polished';
import { themeGet, display, lineHeight, color, fontSize } from 'styled-system';
import { ExternalLink, Text, Box, Flex, Container } from 'roo-ui/components';
import { oneworld } from 'roo-ui/logos';
import {
  CONTACT_US_URL,
  FAQ_URL,
  PRIVACY_AND_SECURITY_URL,
  TERMS_OF_USE_URL,
  AUSTRALIAN_DESTINATIONS_URL,
  TRAVEL_AGENT_LICENSE_NUMBER,
  ABN,
} from 'config/constants';

const Logo = styled.img`
  width: ${rem('40px')};
  margin-right: ${themeGet('space.4')};
  margin-top: -${themeGet('space.2')};
`;

const FooterExternalLink = styled(ExternalLink)`
  ${color};
  ${display};
  ${lineHeight};
  ${fontSize};
`;

FooterExternalLink.defaultProps = {
  ...ExternalLink.defaultProps,
  fontSize: 'sm',
  mr: [0, 4, 0],
  ml: [0, 0, 4],
  py: 1,
  lineHeight: 'tight',
  color: 'greys.steel',
  display: ['block', 'inline-block', 'inline-block'],
};

FooterExternalLink.displayName = 'FooterExternalLink';

const GlobalFooter = () => (
  <Box data-testid="global-footer" pt={[2, 6, 6]} pb={[6, 9, 9]} borderTop={2} borderColor="brand.primary" color="greys.steel" bg="white">
    <Container pt={6} pb={9}>
      <Flex justifyContent="space-between" flexDirection={['column-reverse', 'column-reverse', 'row']}>
        <Flex data-testid="oneworld-info" alignItems="flex-start" mt={[8, 8, 0]}>
          <Logo src={oneworld} alt="One World Logo" role="img" aria-label="One World Logo" />
          <Text fontSize="sm" lineHeight="tight" p={1}>
            Travel agents license No. {TRAVEL_AGENT_LICENSE_NUMBER}
          </Text>
        </Flex>
        <Flex flexDirection="column" justifyContent="flex-end">
          <Box>
            <FooterExternalLink data-testid="global-footer-contact-us" href={CONTACT_US_URL}>
              Contact
            </FooterExternalLink>
            <FooterExternalLink data-testid="global-footer-privacy-and-security" my={[2, 0]} href={PRIVACY_AND_SECURITY_URL}>
              Privacy &amp; Security
            </FooterExternalLink>
            <FooterExternalLink data-testid="global-footer-terms-of-use" my={[2, 0]} href={TERMS_OF_USE_URL}>
              Terms of use
            </FooterExternalLink>
            <FooterExternalLink data-testid="global-footer-australia-destinations" my={[2, 0]} href={AUSTRALIAN_DESTINATIONS_URL}>
              Australian destinations
            </FooterExternalLink>
            <FooterExternalLink data-testid="global-footer-faq" my={[2, 0]} href={FAQ_URL}>
              FAQs
            </FooterExternalLink>
          </Box>
          <Box data-testid="global-footer-abn" textAlign={['left', 'left', 'right']} pr={1}>
            <Text fontSize="sm">&copy; Qantas Airways Limited ABN {ABN}</Text>
          </Box>
        </Flex>
      </Flex>
    </Container>
  </Box>
);

export default GlobalFooter;
